import { StatePropertyRef } from '../ExtendableStore';

export interface ToolInfo {
    id: string;
    state: string;
    param?: any;
}

export const CreateToolInfo = (id: string = 'default', state: string = 'idle', param?: string) => ({ id, state, param }) as ToolInfo;
export const ToolInfo = StatePropertyRef<ToolInfo>('tool', CreateToolInfo());
export const PrevToolInfo = StatePropertyRef<ToolInfo>('PrevTool', CreateToolInfo());
